<template>
  <div class="mdl-card fill">
    <div class="mdl-card__title">
      <h2 class="mdl-card__title-text">{{ 'admin.services.title' | label }} {{ service.label | label }}</h2>
    </div>
    <div v-show="!collapsed">
      <div class="mdl-card__supporting-text fill">
        <div class="mdl-grid">
          <div class="mdl-cell mdl-cell--6-col">
            <div class="profile-label">
              {{ 'admin.services.enabled' | label }}
            </div>
          </div>
          <div class="mdl-cell mdl-cell--6-col">
            <div style="padding-bottom: 20px;">
              <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="{{service.code}}-enabled">
              <input type="checkbox" id="{{service.code}}-enabled" class="mdl-checkbox__input"
                v-model="service.isActive">
                  <span class="mdl-checkbox__label">{{ 'admin.services.enabled' | label }}</span>
              </label>
            </div>
          </div>
          <div class="mdl-cell mdl-cell--12-col">
            <div class="mdl-grid inner-grid" v-for="pricing in service.ServicePricings">
              <div class="mdl-cell mdl-cell--6-col">
                <div class="profile-label">
                  {{billingPeriods[pricing.billingPeriodCode].label | label }}
                  <!--{{ 'admin.services.pricing' | label }}-->
                </div>
              </div>
              <div class="mdl-cell mdl-cell--3-col">
                <div style="padding-bottom: 20px;">
                  <div class="profile-textfield mdl-textfield mdl-js-textfield fill">
                    <input class="mdl-textfield__input" type="number" step="0.01" id="{{service.code}}-{{pricing.billingPeriodCode}}-pricing"
                           v-model="pricing.price">
                  </div>
                </div>
              </div>
              <div class="mdl-cell mdl-cell--3-col" v-if="service.code==='DELAYED'">
                <div style="padding-bottom: 20px;">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="{{service.code}}-{{pricing.billingPeriodCode}}-trial">
                  <input type="checkbox" id="{{service.code}}-{{pricing.billingPeriodCode}}-trial" class="mdl-checkbox__input"
                    v-model="pricing.isTrial">
                      <span class="mdl-checkbox__label">{{'admin.services.pricing.trial' | label}}</span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mdl-card__actions">
        <div class="submit-button mdl-button mdl-js-button mdl-button--raised mdl-button--colored float-right"
        v-on:click="$dispatch('saveService', service)">
          {{'admin.parameters.button.save' | label}}
        </div>
        <div class="clearfix"></div>
      </div>
    </div>
    <div class="mdl-card__menu">
      <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
        v-show="!collapsed"
        v-on:click="collapsed = true">
        <i class="material-icons">keyboard_arrow_up</i>
      </button>
      <button class="mdl-button mdl-button--icon mdl-js-button mdl-js-ripple-effect"
        v-show="collapsed"
        v-on:click="collapsed = false">
        <i class="material-icons">keyboard_arrow_down</i>
      </button>
    </div>
  </div>
</template>

<script>
  module.exports = {
    ready: function () {
    },
    props: {
      service: {
        twoWay: true,
        required: true
      },
      billingPeriods: {
        type: Object,
        required: true
      }
    },
    data: function () {
      return {
        collapsed: false
      }
    }
  }
</script>

<style scoped>
.mdl-card {
  min-height: 0;
}

  .profile-label {
    padding: 4px 0;
  }

  .profile-textfield {
    margin-top: -20px;
  }
  .inner-grid {
    margin: -8px;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// ServiceForm.vue?25319f58